<template>
  <div>
    <b-card
      :title="title"
    >
      <b-card-text>
        <b-table
          ref="refMaterialListTable"
          class="position-relative"
          :items="fetchMaterials"
          responsive
          :fields="tableColumns"
          :sort-by.sync="sortBy"
          :sort-desc.sync="isSortDirDesc"
          primary-key="id"
          show-empty
          empty-text="Without Materials"
        >

          <!-- Column: Created at -->
          <template #cell(id)="data">
            <div class="text-nowrap">
              {{ data.item.created_at }}
            </div>
          </template>

          <!-- Column: Category type -->
          <template #cell(category_type)="data">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                {{ data.item.category_type }}
              </div>
              <div>
                <b-avatar
                  v-for="media in imageMedia(data.item.style_material_media)"
                  :key="media.id"
                  :src="media.image"
                  :style="{width: '3em', height: '3em'}"
                  :title="media.name"
                  square
                  class="mr-1"
                />
              </div>
              <div>
                <b-img
                  v-for="color in data.item.colors"
                  :key="color.id"
                  blank
                  :alt="color.name"
                  :blank-color="color.color"
                  :style="{width: '1.5em', height: '1.5em'}"
                  :title="color.name"
                  class="mr-1"
                  rounded="circle"
                />
                <template
                  v-if="data.item.other_colors"
                >
                  <b-img
                    v-for="color in data.item.other_colors"
                    :key="color.id"
                    blank
                    :alt="color.name"
                    :blank-color="color.color"
                    :style="{width: '1.5em', height: '1.5em'}"
                    :title="color.name"
                    class="mr-1"
                    rounded="circle"
                  />
                </template>
                <template
                  v-if="data.item.other_colors2"
                >
                  <b-img
                    v-for="color in data.item.other_colors2"
                    :key="color.id"
                    blank
                    :alt="color.name"
                    :blank-color="color.color"
                    :style="{width: '1.5em', height: '1.5em'}"
                    :title="color.name"
                    class="mr-1"
                    rounded="circle"
                  />
                </template>
              </div>
            </div>
          </template>

          <!-- Column: Ref -->
          <template #cell(description)="data">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <div
                  class="align-text-top"
                  style="white-space: pre-line"
                >
                  {{ data.item.specifics_description }}
                </div>
                <div
                  class="align-text-top"
                  style="white-space: pre-line"
                >
                  {{ data.item.dimensions_description }}
                </div>
              </div>
              <feather-icon
                v-if="data.item.placement"
                v-b-tooltip.hover
                icon="TargetIcon"
                class="d-inline mr-1"
                :title="data.item.placement"
              />
              <feather-icon
                v-if="data.item.feed && data.item.feed.length != 0"
                icon="MessageCircleIcon"
                class="d-inline mr-1"
              />
            </div>
          </template>

          <!-- Column: Status -->
          <template #cell(status)="data">

            <div class="d-flex flex-column">
              <div class="font-weight-bold">
                {{ data.item.status }}
              </div>
              <div
                v-if="showDate(data.item.status, 'requested_date')"
              >
                Requested: {{ data.item.requested_date }}
              </div>
              <div
                v-if="showDate(data.item.status, 'deadline_date')"
              >
                Deadline: {{ data.item.deadline_date }}
              </div>
              <div
                v-if="showDate(data.item.status, 'sent_date')"
              >
                Sent: {{ data.item.sent_date }}
              </div>
              <div
                v-if="showDate(data.item.status, 'approved_date')"
              >
                Approved: {{ data.item.approved_date }}
              </div>
              <div
                v-if="showDate(data.item.status, 'rejected_date')"
              >
                Rejected: {{ data.item.rejected_date }}
              </div>
            </div>
          </template>
        </b-table>
      </b-card-text>
    </b-card>
    <b-card
      v-if="feed.length > 0"
    >
      <b-card-text>
        <feed
          ref="refFeed"
          :feed="feed"
          :feed-config="feedConfig"
        />
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import {
  BAvatar, BCard, BCardText, BImg, BTable,
} from 'bootstrap-vue'
import {
  computed,
} from '@vue/composition-api'

import useStyleMaterialsList from '../styles-edit/useStyleMaterialsList'
import Feed from '../../feed/Feed.vue'

export default {
  components: {
    BAvatar,
    BCard,
    BCardText,
    BImg,
    BTable,

    Feed,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    fetchMaterials: {
      type: Function,
      required: true,
    },
  },
  setup() {
    const {
      refMaterialListTable,
      sortBy,
      isSortDirDesc,
      showDate,
    } = useStyleMaterialsList()

    const tableColumns = [
      { key: 'category_type' },
      { key: 'description' },
      { key: 'status' },
    ]
    const feedConfig = {
      icons: {
      },
      headers: {
        Comment: 'title-header',
      },
      feedBody: {
        Comment: 'comments-body',
      },
    }

    const feed = computed(() => {
      const allFeeds = []
      if (refMaterialListTable.value) {
        refMaterialListTable.value.localItems.forEach(material => {
          material.feed.forEach(materialFeed => {
            allFeeds.push(materialFeed)
          })
        })
      }
      return allFeeds.sort((a, b) => a.id - b.id)
    })

    const imageMedia = allMedia => allMedia.filter(media => media.image)

    return {
      tableColumns,
      sortBy,
      isSortDirDesc,
      refMaterialListTable,
      imageMedia,
      showDate,
      feed,
      feedConfig,
    }
  },
}
</script>

<style>

</style>
